import { render, staticRenderFns } from "./BindShadow.vue?vue&type=template&id=8e7e0eaa&"
import script from "./BindShadow.vue?vue&type=script&lang=js&"
export * from "./BindShadow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports